// extracted by mini-css-extract-plugin
export default {"title":"wgF33GogNxc30I3BusbO","container":"i8ZpLy8x7b_QaNBqMKSo","center":"dOOoEjzmmgJnou2L1bcD"};